import axios from "axios";
//Headers("Access-Control-Allow-Origin: *");

const instance = axios.create({
  baseURL: "https://us-central1-clone-f612b.cloudfunctions.net/api",
  //"http://127.0.0.1:5001/clone-f612b/us-central1/api", //Where we add the API (cloud function) URL
});

export default instance;

//axios provides easier way to adding baseURL over jsFetch API
